/**
 * ホームページ ヒーロー動画 SP/PC 切り替え
 * media属性のブラウザ依存をなくすためJSで制御する
 */
const homeHeroVideo = () => {
    const video = document.querySelector('.pg-home-hero__video');
    if (!video) return;

    const srcSpWebm = video.dataset.srcSpWebm;
    const srcSpMp4  = video.dataset.srcSpMp4;
    const srcPcWebm = video.dataset.srcPcWebm;
    const srcPcMp4  = video.dataset.srcPcMp4;

    const sourceWebm = video.querySelector('[data-webm]');
    const sourceMp4  = video.querySelector('[data-mp4]');

    const mq = window.matchMedia('(max-width: 1024px)');

    const switchSrc = (isSp) => {
        const newWebm = isSp ? srcSpWebm : srcPcWebm;
        const newMp4  = isSp ? srcSpMp4  : srcPcMp4;

        if (sourceWebm.src === newWebm && sourceMp4.src === newMp4) return;

        sourceWebm.src = newWebm;
        sourceMp4.src  = newMp4;
        video.load();
        video.play().catch(() => {});
    };

    mq.addEventListener('change', (e) => switchSrc(e.matches));
    switchSrc(mq.matches);
};

export default homeHeroVideo;
